const DateHelper = {
  createDate: (dateString) => {
    const date = new Date(dateString)
    const userTimezoneOffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() + userTimezoneOffset);
  },
  formatDate: (dateString) => {
    return DateHelper.createDate(dateString).toLocaleDateString();
  },
  toQrFormat(d) {
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const day = (d.getDate()).toString().padStart(2, '0');
    const hours = (d.getHours()).toString().padStart(2, '0');
    const minutes = (d.getMinutes()).toString().padStart(2, '0');
    const sec = (d.getSeconds()).toString().padStart(2, '0');
    return `${month}${day}${d.getFullYear()}-${hours}${minutes}${sec}`;
  },
};

export default DateHelper;